module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/modules/$.redefine.js
// module id = 103
// module chunks = 0